import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const AnimatedCounter = ({ value }) => {
  const formattedValue = typeof value === "number" ? value.toLocaleString() : value;

  return (
    <span className="inline-flex overflow-hidden relative leading-[1.1] align-bottom">
      <AnimatePresence mode="popLayout" initial={false}>
        <motion.span
          key={value}
          initial={{ y: "100%", opacity: 0 }}
          animate={{ y: "0%", opacity: 1 }}
          exit={{ y: "-100%", opacity: 0 }}
          transition={{
            type: "spring",
            stiffness: 400,
            damping: 30,
            mass: 0.8
          }}
          className="inline-block whitespace-nowrap"
        >
          {formattedValue}
        </motion.span>
      </AnimatePresence>
    </span>
  );
};

export default AnimatedCounter;
